import { CorrelationParams, createEntityActions, createTypedAction, EntityActionType, newAggregationId } from '@aston/foundation';
import { createAction, props } from '@ngrx/store';
import { ISubsidiaryListItem } from 'apps/console/src/app/subsidiaries-module/models';

const ActionPrefix = 'Subsidiaries';

export const SubsidiariesActions = {
	...createEntityActions<{ subsidiaries: ISubsidiaryListItem[], hasPendingItems: boolean }>(ActionPrefix, 'List'),

	LoadSubsidiariesRequest: createTypedAction(
		EntityActionType.LoadEntityRequest,
		`[${ActionPrefix}] Load List Request`,
		(correlationParams: CorrelationParams = { correlationId: newAggregationId() }) => ( { correlationParams } )
	),
	LoadSubsidiariesSuccess: createTypedAction(
		EntityActionType.LoadEntitySuccess,
		`[${ActionPrefix}] Load List Success`,
		props<{ entity: ISubsidiaryListItem[], hasPendingItems: boolean, correlationParams?: CorrelationParams }>()
	),
	LoadSubsidiariesFailure: createTypedAction(
		EntityActionType.LoadEntityFailure,
		`[${ActionPrefix}] Load List Failure`,
		props<{ error: Error }>()
	),
};

export const {
	LoadSubsidiariesRequest,
	LoadSubsidiariesSuccess,
	LoadSubsidiariesFailure
} = SubsidiariesActions;

export const RedirectToTenant = createAction(`[${ActionPrefix}] Redirect To Tenant`, props<{ subsidiaryId: number, path?: string }>());

export const RedirectToTenantNewTab = createAction(`[${ActionPrefix}] Redirect To Tenant new Tab`, props<{ subsidiaryId: number }>());

export const subsidiariesTimeoutActions = createEntityActions<{ id: number, date: Date }>(ActionPrefix, 'Tenant Timeout');
export const {
	UpdateEntityConfirm: SetTenantTimeoutConfirm,
	UpdateEntityRequest: SetTenantTimeoutRequest,
	UpdateEntitySuccess: SetTenantTimeoutSuccess,
	UpdateEntityFailure: SetTenantTimeoutFailure,
} = subsidiariesTimeoutActions;
